import React, { useEffect, useState } from 'react'
import { ICharacter } from '../../../../../../api/types/character'
import { MarkdownComponent } from '../../../../../../components/Markdown/MarkdownComponent'
import { FormRow } from '../../../../../../components/FormRow/FormRow'
import { Button, TextareaAutosize, Theme } from '@mui/material'
import { SubmitButton } from '../../../../../../components/SubmitButton/SubmitButton'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { useMutation } from '@tanstack/react-query'
import { mutationUpdateCharacterNotes } from '../../../../../../api/mutations'
import { useGlobalError } from '../../../../../../context/GlobalError'
import { extractMessage } from '../../../../../../utils'
import cx from 'classnames'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    alignToRight: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
      maxHeight: window.innerHeight * 0.7,
    },
    content: {
      overflow: 'auto',
    },
    clickToEdit: {
      width: '100%',
      padding: '4px',
      paddingTop: '20px',
      paddingBottom: '20px',
      fontStyle: 'italic',
      textAlign: 'center',
    },
  })
)

interface Props {
  character: ICharacter
}

export const CharacterNotes: React.FC<Props> = ({ character }) => {
  const { addError } = useGlobalError()
  const [editMode, setEditMode] = useState(false)
  const [notes, setNotes] = useState(character.notes)
  const classes = useStyles()
  const { mutate, isLoading } = useMutation(
    (notes: string) => mutationUpdateCharacterNotes(character.id, notes),
    {
      onError: (err: any) => {
        addError(extractMessage(err) || 'Nie udało się zaktualizować notatek', err?.status)
      },
      onSuccess: data => {
        setNotes(data.data.notes)
      },
    }
  )

  useEffect(() => setNotes(character.notes), [character.notes])

  const handleSubmit = (e: any) => {
    e.preventDefault()
    mutate(notes)
    setEditMode(false)
  }

  return (
    <div className={classes.root}>
      {!editMode && (
        <div className={cx(classes.content)} onClick={() => setEditMode(true)}>
          {notes && <MarkdownComponent rawMarkdown={notes} />}
          {!notes && <div className={classes.clickToEdit}>Kliknij tutaj aby edytować</div>}
        </div>
      )}

      {editMode && (
        <form onSubmit={handleSubmit} className={classes.root}>
          <div className={classes.content}>
            <FormRow>
              <TextareaAutosize
                style={{ width: '100%' }}
                name="contents"
                value={notes}
                onChange={e => setNotes(e.target.value)}
                minRows={10}
              />
            </FormRow>
          </div>
          <div className={classes.alignToRight} style={{ marginTop: '6px' }}>
            <Button
              style={{ marginRight: '4px' }}
              variant="outlined"
              onClick={() => setEditMode(false)}
            >
              Anuluj
            </Button>
            <SubmitButton disabled={isLoading}>Zapisz</SubmitButton>
          </div>
        </form>
      )}
    </div>
  )
}
